import { Injectable } from '@angular/core';
import { StorageService } from '@apps/ui';

@Injectable()
export class LoadService {
  constructor(private storage: StorageService) {}

  async initializeApp(): Promise<boolean> {
    // load config
    const config = {};
    this.storage.setItem('config', config);
    return true;
  }
}
